const DEFAULT_TIMEOUT_MS = 300;

const buildDedupeKey = ({ type, paywall, value, clientReferenceId, extraKey }) => {
  const base = [
    "purchase",
    type || "",
    paywall || "",
    value != null ? String(value) : "",
    clientReferenceId || "",
    extraKey || "",
  ].join("|");
  return base;
};

const markIfNew = (dedupeKey) => {
  try {
    const storageKey = `gtm_purchase_${dedupeKey}`;
    if (sessionStorage.getItem(storageKey)) {
      return false;
    }
    sessionStorage.setItem(storageKey, "1");
    return true;
  } catch (_) {
    return true;
  }
};

export const pushPurchaseEvent = ({
  clientReferenceId,
  paywall,
  value,
  type,
  extraKey,
  timeoutMs = DEFAULT_TIMEOUT_MS,
} = {}) => {
  if (typeof window === "undefined") return Promise.resolve();

  const dedupeKey = buildDedupeKey({ type, paywall, value, clientReferenceId, extraKey });
  const isNew = markIfNew(dedupeKey);
  if (!isNew) return Promise.resolve();

  const dl = (window.dataLayer = window.dataLayer || []);

  return new Promise((resolve) => {
    const timer = setTimeout(resolve, timeoutMs);

    const payload = {
      event: "purchase",
      client_reference_id: clientReferenceId,
      paywall,
      value: value != null ? Number(value) : undefined,
      type,
      eventCallback: () => {
        clearTimeout(timer);
        resolve();
      },
    };

    dl.push(payload);
  });
};

